module.exports = __webpack_public_path__ + "images/canonical-card/alert-taco.4f0613d1118d1c1a2592.svg";